import { render, staticRenderFns } from "./A2PRegistrationWizard.vue?vue&type=template&id=36ac87f8&scoped=true"
import script from "./A2PRegistrationWizard.vue?vue&type=script&lang=js"
export * from "./A2PRegistrationWizard.vue?vue&type=script&lang=js"
import style0 from "./a2p-wizard.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./A2PRegistrationWizard.vue?vue&type=style&index=1&id=36ac87f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac87f8",
  null
  
)

export default component.exports